var render, staticRenderFns
import script from "./GTimelineItem.vue?vue&type=script&lang=ts&"
export * from "./GTimelineItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f50a6fe",
  null
  
)

export default component.exports